import * as React from "react"
const IconLink = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 19}
        height={props.height ?? 19}
        viewBox="0 0 19 19"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke ?? "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth ?? 2}
            d="M7.62 10.111a4.168 4.168 0 0 0 6.283.45l2.5-2.5a4.167 4.167 0 0 0-5.892-5.891L9.078 3.595m1.875 4.85a4.167 4.167 0 0 0-6.283-.45l-2.5 2.5a4.167 4.167 0 0 0 5.891 5.891l1.425-1.425"
        />
    </svg>
)
export default IconLink
